export enum NotificationType {
    Message = 'message',
    Report = 'report',
    OpenForm = 'open_form',
    Update = 'update'
}
